import { FormControlLabel, Switch } from '@mui/material';
import { useField } from 'formik';

export default function SwitchField(props) {
    const [field, __, helper] = useField(props.name);

    const handleChange = event => {
        helper.setValue(event.target.checked);
    };

    return (
        <FormControlLabel
            sx={{ m: '4px 0 12px 0', display: 'block' }}
            control={<Switch checked={field.value == '1' || field.value === true} {...props} onChange={handleChange} />}
            label={props.label ?? ''}
        />
    );
}
